import Navbar from './components/Navbar';
import Notes from './components/notes/Notes';
import { useState } from 'react';
import NotesProvider from './store/NotesProvider';

function App() {
  const [showSidebar, setShowSidebar] = useState(true);

  const toggleSidebar = () => {
    setShowSidebar((prevState) => !prevState);
  };

  return (
    <NotesProvider>
      <Navbar toggleSidebar={toggleSidebar} />
      <Notes sidebar={showSidebar} />
    </NotesProvider>
  );
}

export default App;
